import styled from 'styled-components'

export const ButtonsWrapper = styled.div`
  display: flex;

  > * + * {
    margin-inline-start: 10px;
  }
`
